import React, { Fragment, useEffect, useState } from "react";
import HeaderWeb from "../Account/HeaderWeb";
import HomeLeft from "./HomeLeft";
import HomeRight from "./HomeRight";
import { useLocation } from "react-router-dom";
import BetSlipContext from "../../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";

const WebSkyLayout = ({ eventName, gameType, seriesName, children }) => {
  const location = useLocation();
  const betLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betLoader;
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // adjust duration

    return () => clearTimeout(timer);
  }, [location]); // ⚡ use location.key instead of pathname
  return (
    <Fragment>
      <HeaderWeb />
      <div className="full-wrap">
        {(betLoader || loading) && (
          <div
            id="loading"
            className="loading-wrap"
            style={{ top: "260px", display: "block" }}
          >
            <ul className="loading">
              <li>
                <img src="/assets/images/loading40.gif" />
              </li>
              <li>Loading...</li>
              <br />
              <li>
                <span id="progress" />
              </li>
            </ul>
          </div>
        )}
        {!["inplay-sky", "result-sky"].includes(
          location?.pathname?.split("/")[1]
        ) && (
          <HomeLeft
            eventName={eventName}
            gameType={gameType}
            seriesName={seriesName}
          />
        )}
        {children} <HomeRight />
      </div>{" "}
    </Fragment>
  );
};

export default WebSkyLayout;
